import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tab } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = (theme) => ({
  root: {
    textTransform: 'none',
    color: theme.palette.primary.main,
    fontSize: theme.typography.h6.fontSize,
    marginRight: theme.spacing(1),
    opacity: 0.7,
    fontWeight: theme.typography.fontWeightFacetMedium,
    '&:focus': {
      opacity: 1,
    },
    '&:hover': {
      opacity: 1,
    },
    '&.Mui-selected': {
      opacity: 1,
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightFacetBold,
    },
  },
});

const FacetTab = ({
  className,
  classes,
  value,
  label,
  ...rest
}) => {
  return (
    <Tab
      className={classNames(classes.root, className)}
      value={value}
      label={label}
      disableRipple
      test={`facet-plan-facet-tab-${label}`}
      {...rest} // <---- Needed - Adds callback prop to notify the parent <Tabs /> a new tab has been selected
    />
  );
};

FacetTab.defaultProps = {
  className: '',
};

FacetTab.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default withStyles(styles)(FacetTab);
